import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Navbar = () => (
<nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
<div className="container">
<a className="navbar-brand" href="#">👑Royal Marriage Garden</a>
<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navMenu">
<span className="navbar-toggler-icon"></span>
</button>
<div className="collapse navbar-collapse" id="navMenu">
<ul className="navbar-nav ms-auto">
<li className="nav-item"><a className="nav-link" href="#about">About</a></li>
<li className="nav-item"><a className="nav-link" href="#services">Services</a></li>
<li className="nav-item"><a className="nav-link" href="#gallery">Gallery</a></li>
<li className="nav-item"><a className="nav-link" href="#pricing">Packages</a></li>
<li className="nav-item"><a className="nav-link" href="#contact">Contact</a></li>
</ul>
</div>
</div>
</nav>
);

const Hero = () => (
<header style={{backgroundImage:"url('/images/image2.webp')", backgroundSize:'cover', backgroundPosition:'center'}} className="text-white text-center py-5">
<div style={{background:'rgba(183, 149, 1)'}} className="py-5">
<div className="container">
<h1 className="display-4 fw-bold">Royal Marriage Garden</h1>
<p className="lead">Where Your Dream Wedding Becomes Reality</p>
<a href="#contact" className="btn btn-warning btn-lg me-2">Book Now</a>
<a href="https://wa.me/916269278862?text=Hi%20I%20want%20to%20book%20Royal%20Marriage%20Garden" target="_blank" rel="noreferrer" className="btn btn-success btn-lg">WhatsApp</a>
</div>
</div>
</header>
);

const About = () => (
  <section id="about" className="container py-5 text-center">
    <h2 className="fw-bold mb-4">About Us</h2>
    <p className="lead"><i>Royal Marriage Garden offers luxurious lawns, premium decoration, and world-class arrangements to make your wedding day unforgettable. Spacious lawns, elegant seating, and professional staff for a seamless event.</i></p>
  </section>
);

const Services = () => (
  <section id="services" className="bg-light py-5">
    <div className="container">
      <h2 className="text-center fw-bold mb-4">Our Services</h2>
      <div className="row g-4 text-center">
        <div className="col-md-4">
          <div className="card h-100 border-1 shadow-sm">
            <div className="card-body">
              <h5>Decoration</h5>
              <p>Elegant Royal Themes, Stage Setup & Floral Decor</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card h-100 border-1 shadow-sm">
            <div className="card-body">
              <h5>Catering</h5>
              <p>Multi-Cuisine Menus, Live Counters & Premium Service</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card h-100 border-1 shadow-sm">
            <div className="card-body">
              <h5>Photography & Video</h5>
              <p>HD Coverage, Candid Photographers, Drone Shots</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const Gallery = () => (
  <section id="gallery" className="container py-5">
    <h2 className="text-center fw-bold mb-4">Gallery</h2>
    <div className="row g-3">
      <div className="col-md-4">
        <img src="https://cdn0.weddingwire.in/vendor/4517/3_2/960/jpg/00gp1517_15_214517-171964822354883.webp" alt="gallery1" className="img-fluid rounded shadow-sm" />
      </div>
      <div className="col-md-4">
        <img src="https://cdn0.weddingwire.in/vendor/4517/3_2/960/jpg/00gp1514_15_214517-171964822566939.webp" alt="gallery2" className="img-fluid rounded shadow-sm" />
      </div>
      <div className="col-md-4">
        <img src="https://cdn0.weddingwire.in/vendor/4517/3_2/960/jpg/sto-9057_15_214517-171964826319064.webp" alt="gallery3" className="img-fluid rounded shadow-sm" />
      </div>
       <div className="col-md-4">
        <img src="https://cdn0.weddingwire.in/vendor/6328/3_2/960/jpg/file-1759046904680_15_276328-175904690825445.webp" alt="gallery1" className="img-fluid rounded shadow-sm" />
      </div>
      <div className="col-md-4">
        <img src="https://cdn0.weddingwire.in/vendor/6328/3_2/960/jpg/file-1758090937549_15_276328-175809094081257.webp" alt="gallery2" className="img-fluid rounded shadow-sm" />
      </div>
      <div className="col-md-4">
        <img src="https://cdn0.weddingwire.in/vendor/7625/3_2/960/jpg/-dsc0829_15_137625-175706421743632.webp" alt="gallery3" className="img-fluid rounded shadow-sm" />
      </div>
    </div>
  </section>
);

const Pricing = () => (
  <section id="pricing" className="bg-light py-5">
    <div className="container">
      <h2 className="text-center fw-bold mb-4">Packages</h2>
      <div className="row g-4">
        <div className="col-md-4">
          <div className="card h-100 text-center shadow-sm">
            <div className="card-body">
              <h5>Silver</h5>
              <p>Basic Decoration + Seating</p>
              <p className="fw-bold">₹25,000</p>
              <a href="#contact" className="btn btn-outline-primary">Select</a>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card h-100 text-center shadow-sm">
            <div className="card-body">
              <h5>Gold</h5>
              <p>Decoration + Catering (100 guests)</p>
              <p className="fw-bold">₹60,000</p>
              <a href="#contact" className="btn btn-outline-primary">Select</a>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card h-100 text-center shadow-sm">
            <div className="card-body">
              <h5>Royal</h5>
              <p>Full Service: Decor, Catering, Photography</p>
              <p className="fw-bold">Custom</p>
              <a href="#contact" className="btn btn-outline-primary">Select</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    // Simple client-side: open mailto with filled info
    const name = data.get('name');
    const email = data.get('email');
    const message = data.get('message');
    const subject = encodeURIComponent('Booking enquiry - Royal Marriage Garden');
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`);
    window.location.href = `mailto:royalmarriagegarden@example.com?subject=${subject}&body=${body}`;
  };

  return (
    <section id="contact" className="container py-5">
      <h2 className="text-center fw-bold mb-4">Contact & Booking</h2>
      <div className="row">
        <div className="col-md-6">
          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-12"><input name="name" required className="form-control" placeholder="Your Name" /></div>
            <div className="col-12"><input name="email" type="email" required className="form-control" placeholder="Email" /></div>
            <div className="col-12"><textarea name="message" rows="4" required className="form-control" placeholder="Message"></textarea></div>
            <div className="col-12"><button className="btn btn-warning">Send Inquiry</button></div>
          </form>
          <div className="mt-4">
            <p className="mb-1"><strong>Phone:</strong> +91 6269278862</p>
            <p className="mb-1"><strong>Email:</strong> royalmarriagegarden@gmail.com</p>
            <p className="mb-1"><strong>Location:</strong> Chakghat Road, Sonauri</p>
            <a href="https://wa.me/919876543210?text=Hello%20Royal%20Garden" target="_blank" rel="noreferrer" className="btn btn-success mt-2">Message on WhatsApp</a>
          </div>
        </div>
        <div className="col-md-6">
          <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d57900.07145999145!2d81.8298546!3d24.9063555!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39856d001b79cbf3%3A0xc2299e6e3e31245f!2sROYAL%20MARRIAGE%20GARDEN!5e0!3m2!1sen!2sin!4v1761150763306!5m2!1sen!2sin" width="100%" height="320" style={{border:0}} allowFullScreen loading="lazy"></iframe>
        </div>
      </div>
    </section>
  );
};

const Footer = () => (
  <footer className="bg-dark text-white text-center py-3 mt-5">
    <div className="container">
      <p className="mb-0">© {new Date().getFullYear()} Royal Marriage Garden. All Rights Reserved.</p>
    </div>
  </footer>
);

export default function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Services />
      <Gallery />
      <Pricing />
      <Contact />
      <About />
      <Footer />
    </div>
  );
}